import { Contract } from "appworks/utils/contracts/contract";
import { PartnerConnectHistorySpinCommand } from "partner-connect/commands/partner-connect-history-spin-command";
import { PartnerConnectHistorySpin } from "partner-connect/states/partner-connect-history-spin";

export class TGRPartnerConnectHistoryFreespin extends PartnerConnectHistorySpin {

    protected startSpinning(): Contract<any> {
        return PartnerConnectHistorySpinCommand();
    }
}
